import { useQuery } from "@tanstack/react-query";
import { auditService } from "audit/services";
import { useBoundStore } from "store";

export const auditKeys = {
  all: ["audit"] as const,
  info: (tenantId?: string, organizationId?: string) =>
    [...auditKeys.all, "tenant", tenantId ?? "unknown", "organization", organizationId ?? "unknown", "info"] as const,
};

/**
 * Fetches audit info for an organization.
 */
export function useAuditInfo(
  organizationId?: string,
  options?: { enabled?: boolean }
) {
  const { tenant } = useBoundStore();

  return useQuery({
    queryKey: auditKeys.info(tenant?.id, organizationId),
    queryFn: () => auditService.getAuditInfo(tenant!.id, organizationId as string),
    enabled: !!tenant?.id && !!organizationId && (options?.enabled ?? true),
    staleTime: 5 * 60_000,
    ...options,
  });
}
